import {useMapContext} from '@/components/MindMap/index.mjs'
import ButtonExportModel from '../components/PropertiesPaneButtonExportModel.jsx'
import ArchPropertiesPane from '../_ARCH/ArchPropertiesPane.jsx'
import ButtonImportProductsFromXls from '../_DESIGN/PropertiesPaneButtonImportProductsFromXls.jsx'

export default function PropertiesPaneBa(props) {
    const map = useMapContext()
    const {mapTypeCode, prjTypeCode, subTypeCode} = map.data
    const [node] = map.useSelectedNodes()

    const buttons = (() => {
        if ('SA_MAP' === mapTypeCode) {
            for (const n of map.trueChain(node.parent)) {
                const {bizNodeType} = n.data

                if (bizNodeType !== node.data.bizNodeType) {
                    if ('CAT_DATA' === bizNodeType) {
                        return null
                    }
                }
            }
        }

        if (
            'BM' === prjTypeCode ||
            'BODA2' === subTypeCode
        ) {
            return (
                <ButtonImportProductsFromXls type="bm">
                    导入业务结构
                </ButtonImportProductsFromXls>
            )
        }
        else {
            return (
                <>
                    <ButtonExportModel global type="bm" />
                    <ButtonExportModel global type="bf" />
                    <ButtonExportModel global type="bdterm" />
                    <ButtonExportModel global type="bdrule" />
                    <ButtonExportModel global type="bdsummary" />
                    <ButtonExportModel global type="bdlogic" />

                    <ButtonImportProductsFromXls type="bm">
                        导入业务结构
                    </ButtonImportProductsFromXls>
                </>
            )
        }
    })()

    return (
        <ArchPropertiesPane
            buttons={buttons}
            {...props}
        />
    )
}
